import type IProductParams from '../interfaces/IProductParams';

// eslint-disable-next-line complexity
export const getProductByAlias = (alias: string): IProductParams => {
  switch (alias) {
    case 'enciklopediya':
      return {
        name: 'Путеводитель по энциклопедии',
        prepositional: 'о путеводителе',
        description: 'Путеводитель по энциклопедии',
        category: 'enciklopediya',
      };
    case 'karty':
      return {
        name: 'Кредитная карта',
        prepositional: 'о кредитных картах',
        description: 'Кредитные карты',
        category: 'banks',
        url: '/karty/',
      };
    case 'debetovye-karty':
      return {
        name: 'Дебетовая карта',
        prepositional: 'о дебетовых картах',
        description: 'Дебетовые карты',
        category: 'banks',
        url: '/debetovye-karty/',
      };
    case 'kredity':
      return {
        name: 'Кредит',
        prepositional: 'о кредитах',
        description: 'Кредиты',
        category: 'banks',
        url: '/kredity/',
      };
    case 'avtokredity':
      return {
        name: 'Автокредит',
        prepositional: 'об автокредитах',
        prepositionalSingle: 'об автокредите',
        description: 'Автокредит',
        category: 'banks',
        url: '/avtokredity/',
      };
    case 'ipoteka':
      return {
        name: 'Ипотека',
        prepositional: 'об ипотеке',
        description: 'Ипотека',
        category: 'banks',
        url: '/ipoteka/',
      };
    case 'vklady':
      return {
        name: 'Вклад',
        prepositional: 'о вкладах',
        description: 'Вклады',
        category: 'banks',
        url: '/vklady/',
      };
    case 'valjuty':
      return {
        name: 'Курс Валют',
        prepositional: 'о валютах',
        description: 'Валюты',
        category: 'banks',
        url: '/valjuty/',
      };
    case 'perevody':
      return {
        name: 'Перевод денег',
        prepositional: 'о переводах денег',
        description: 'Переводы денег',
        category: 'banks',
        url: '/perevody/',
      };
    case 'strafy-gibdd':
      return {
        name: 'Оплата штрафов ГИБДД',
        prepositional: 'об оплате штрафов ГИБДД',
        description: 'Оплата штрафов ГИБДД',
        category: 'banks',
        url: '/oplata/proverka-avto-shtrafy-gibdd/',
      };
    case 'rko':
      return {
        name: 'РКО',
        prepositional: 'об РКО',
        descrPrepositional: 'о рассчётно-кассовом обслуживании',
        description: 'Рассчётно-кассовое обслуживание',
        category: 'banks',
        url: '/rko/',
      };
    case 'zaimy':
      return {
        name: 'Микрокредит',
        prepositional: 'о микрокредитах',
        prepositionalSingle: 'о микрокредите',
        description: 'Микрокредит',
        category: 'banks',
        url: '/zaimy/',
      };
    case 'kasko':
      return {
        name: 'Каско',
        prepositional: 'о каско',
        description: 'каско',
        category: 'insurance',
        url: '/kasko/',
      };
    case 'osago':
      return {
        name: 'ОСАГО',
        prepositional: 'об ОСАГО',
        description: 'ОСАГО',
        category: 'insurance',
        url: '/osago/',
      };
    case 'strahovanie-nedvizhimosti':
      return {
        name: 'Страхование недвижимости',
        prepositional: 'о страховании недвижимости',
        description: 'Страхование недвижимости',
        category: 'insurance',
        url: '/strahovanie-doma/',
      };
    case 'strahovanie-ipoteki':
      return {
        name: 'Страхование ипотеки',
        prepositional: 'о страховании ипотеки',
        description: 'Страхование ипотеки',
        category: 'insurance',
        url: '/strahovanie-ipoteki/',
      };
    case 'strahovanie-ns':
      return {
        name: 'Страхование от несчастного случая',
        prepositional: 'о страховании от несчастного случая',
        description: 'Страхование от несчастного случая',
        category: 'insurance',
        url: '/strahovanie-ns/',
      };
    case 'vzr':
      return {
        name: 'ВЗР',
        prepositional: 'о ВЗР',
        descrPrepositional: 'о страховании путешествий',
        description: 'Страхование путешествий',
        category: 'insurance',
        url: '/vzr/',
      };
    case 'health':
      return {
        name: 'Страхование здоровья',
        prepositional: 'о страховании здоровья',
        description: 'Страхование здоровья',
        category: 'insurance',
      };
    case 'HealthInsurance':
      return {
        name: 'Страхование здоровья',
        prepositional: 'о страховании здоровья',
        description: 'Страхование здоровья',
        category: 'insurance',
      };
    case 'Accident':
      return {
        name: 'Страхование от несчастного случая',
        prepositional: 'о НС',
        descrPrepositional: 'о страховании от несчастного случая',
        description: 'Страхование от несчастного случая',
        category: 'insurance',
      };
    case 'Dms':
      return {
        name: 'Добровольное медицинское страхование',
        prepositional: 'о ДМС',
        descrPrepositional: 'о добровольном медицинском страховании',
        description: 'Добровольное медицинское страхование',
        category: 'insurance',
        url: '/dms/',
      };
    case 'Npf':
      return {
        name: 'Негосударственные пенсионные фонды',
        prepositional: 'о НПФ',
        descrPrepositional: 'о негосударственных пенсионных фондах',
        description: 'Негосударственные пенсионные фонды',
        category: 'insurance',
      };
    case 'Nszh':
      return {
        name: 'Накопительное страхование жизни',
        prepositional: 'о НСЖ',
        descrPrepositional: 'о накопительном страховании жизни',
        description: 'Накопительное страхование жизни',
        category: 'insurance',
      };
    case 'banki':
      return {
        name: 'Банки',
        prepositional: 'о банках',
        descrPrepositional: 'по банкам',
        description: 'Банки',
        category: 'banks',
        url: '/banki/',
      };
    case 'kursy':
      return {
        name: 'Онлайн курсы',
        prepositional: 'об онлайн курсах',
        descrPrepositional: 'об онлайн курсах',
        description: 'Онлайн курсы',
        url: '/kursy/',
      };
    case 'bankovskie-garantii':
    case 'bg':
      return {
        name: 'Банковские гарантии',
        prepositional: 'о банковских гарантиях',
        descrPrepositional: 'о банковских гарантиях',
        description: 'Банковские гарантии',
        url: '/biznes/bankovskie-garantii/',
      };
    case 'ekvajring':
      return {
        name: 'Эквайринг',
        prepositional: 'об эквайринге',
        descrPrepositional: 'об эквайринге',
        description: 'Эквайринг',
        url: '/biznes/ekvajring/',
      };
    case 'deposit':
      return {
        name: 'Вклады для бизнеса',
        prepositional: 'о бизнес вкладах',
        descrPrepositional: 'о бизнес вкладах',
        description: 'Вклады для бизнеса',
        url: '/biznes/vklady/',
      };
    case 'kredity-dlya-biznesa':
      return {
        name: 'Кредиты для бизнеса',
        prepositional: 'о бизнес кредитах',
        descrPrepositional: 'о бизнес кредитах',
        description: 'Кредиты для бизнеса',
        url: '/biznes/kredity/',
      };
    case 'zarplatnyj-proekt':
      return {
        name: 'Зарплатный проект',
        prepositional: 'о зарплатном проекте',
        descrPrepositional: 'о зарплатном проекте',
        description: 'Зарплатный проект',
        url: '/biznes/zarplatnyj-proekt/',
      };
    case 'vysshee-i-srednee-obrazovanie':
      return {
        name: 'Высшее и среднее образование',
        prepositional: 'о высшем и среднем образовании',
        descrPrepositional: 'о высшем и среднем образовании',
        description: 'Высшее и среднее образование',
        url: '/kursy/',
      };
    case 'ege-oge':
      return {
        name: 'Подготовка к ЕГЭ и ОГЭ',
        prepositional: 'о подготовке к ЕГЭ и ОГЭ',
        descrPrepositional: 'о подготовке к ЕГЭ и ОГЭ',
        description: 'Подготовка к ЕГЭ и ОГЭ',
        url: '/kursy/',
      };
    case 'strahovanie-domov':
      return {
        name: 'Страхование дома',
        prepositional: 'о страховании дома',
        descrPrepositional: 'о страховании дома',
        description: 'Страхование дома',
        url: '/strahovanie-domov/',
      };
    case 'brokery':
      return {
        name: 'Брокеры',
        prepositional: 'о брокерах',
        descrPrepositional: 'о брокерах',
        description: 'Брокеры',
        url: '/invest/brokerskoe-obsluzhivanie/',
      };
    case 'fondy':
      return {
        name: 'Фонды',
        prepositional: 'о фондах',
        descrPrepositional: 'о фондах',
        description: 'Фонды',
        url: '/invest/brokerskoe-obsluzhivanie/',
      };
    case 'akcii':
      return {
        name: 'Акции',
        prepositional: 'об акциях',
        descrPrepositional: 'об акциях',
        description: 'Акции',
        url: '/invest/brokerskoe-obsluzhivanie/',
      };
    case 'obligacii':
      return {
        name: 'Облигации',
        prepositional: 'об облигациях',
        descrPrepositional: 'об облигациях',
        description: 'Облигации',
        url: '/invest/brokerskoe-obsluzhivanie/',
      };
    case 'iis':
      return {
        name: 'Индивидуальный Инвестиционный Счет',
        prepositional: 'о ИИС',
        descrPrepositional: 'о ИИС',
        description: 'Индивидуальный Инвестиционный Счет',
      };
    case 'registraciya-ip-yur-lic':
      return {
        name: 'Регистрация для ИП и юридических лиц',
        prepositional: 'о регистрации для ИП и юридических лиц',
        descrPrepositional: 'о регистрации для ИП и юридических лиц',
        description: 'Регистрация для ИП и юридических лиц',
      };
    case 'franshizy':
      return {
        name: 'Франшизы',
        prepositional: 'о франшизах',
        descrPrepositional: 'о франшизах',
        description: 'Франшизы',
      };
    case 'biznes-marketplace':
      return {
        name: 'Бизнес маркетплейс',
        prepositional: 'о бизнес маркетплейсе',
        descrPrepositional: 'о бизнес маркетплейсе',
        description: 'Бизнес маркетплейс',
        url: '/biznes-marketplace/',
      };
    case 'invest-strahovanie':
      return {
        name: 'Инвестиционное страхование',
        prepositional: 'о инвестиционном страховании',
        descrPrepositional: 'о инвестиционном страховании',
        description: 'Инвестиционное страхование',
        url: '/invest-strahovanie/',
      };
    case 'bankrotstvo':
      return {
        name: 'Банкротство',
        prepositional: 'по банкротству',
        descrPrepositional: 'по банкротству',
        description: 'Банкротство',
        url: '/bankrotstvo/',
      };
    case 'biznes-vnesenie-izmeneniy':
      return {
        name: 'ОКВЭД',
        prepositional: 'по ОКВЭД',
        descrPrepositional: 'по ОКВЭД',
        description: 'ОКВЭД',
        url: '/biznes-vnesenie-izmeneniy/',
      };
    case 'biznes-leasing':
      return {
        name: 'Лизинг',
        prepositional: 'по лизингу',
        descrPrepositional: 'по лизингу',
        description: 'Лизинг',
        url: '/biznes-leasing/',
      };
    case 'biznes-likvidaciya':
      return {
        name: 'Сервис ликвидации',
        prepositional: 'о сервисе ликвидации',
        descrPrepositional: 'о сервисе ликвидации',
        description: 'Сервис ликвидации',
        url: '/biznes-likvidaciya/',
      };
    case 'biznes-kredity':
      return {
        name: 'Кредиты для бизнеса',
        prepositional: 'о кредиты для бизнеса',
        descrPrepositional: 'о кредиты для бизнеса',
        description: 'Кредиты для бизнеса',
        url: '/biznes-kredity/',
      };
    case 'biznes-ekvajring':
      return {
        name: 'Эквайринг',
        prepositional: 'по эквайрингу',
        descrPrepositional: 'по эквайрингу',
        description: 'Эквайринг',
        url: '/biznes/ekvajring/',
      };
    case 'biznes-vklady':
      return {
        name: 'Депозиты для бизнеса',
        prepositional: 'о депозитах для бизнеса',
        descrPrepositional: 'о депозитах для бизнеса',
        description: 'Депозиты для бизнеса',
        url: '/biznes-vklady/',
      };
    case 'biznes-registration':
      return {
        name: 'Регистрация бизнеса',
        prepositional: 'о регистрации бизнеса',
        descrPrepositional: 'о регистрации бизнеса',
        description: 'Регистрация бизнеса',
        url: '/biznes-registration/',
      };
    case 'biznes-ved':
      return {
        name: 'ВЭД',
        prepositional: 'о ВЭД',
        descrPrepositional: 'о ВЭД',
        description: 'ВЭД',
        url: '/biznes-ved/',
      };
    case 'npf-programmy':
      return {
        name: 'НПФ программы',
        prepositional: 'о НПФ программах',
        descrPrepositional: 'о НПФ программах',
        description: 'НПФ программы',
        url: '/npf-programmy/',
      };
    case 'sport':
      return {
        name: 'Спорт',
        prepositional: 'о спорте',
        descrPrepositional: 'о спорте',
        description: 'Спорт',
        url: '/sport/',
      };
    case 'investicii-v-biznes':
      return {
        name: 'Инвестиции в бизнес',
        prepositional: 'об инвестициях в бизнес',
        descrPrepositional: 'об инвестициях в бизнес',
        description: 'Инвестиции в бизнес',
        url: '/invest/investicii-v-biznes/',
      };
    case 'cfa':
      return {
        name: 'ЦФА',
        prepositional: 'о ЦФА',
        descrPrepositional: 'о ЦФА',
        description: 'ЦФА',
        url: '/cfa/',
      };
    case 'booking-avia':
      return {
        name: 'Авиа-билеты',
        prepositional: 'о Авиа-билетах',
        descrPrepositional: 'о Авиа-билетах',
        description: 'Авиа-билеты',
        url: '/booking-avia/',
      };
    case 'booking-rw':
      return {
        name: 'Ж/Д-билеты',
        prepositional: 'о Ж/Д-билетах',
        descrPrepositional: 'о Ж/Д-билетах',
        description: 'Ж/Д-билеты',
        url: '/booking-rw/',
      };
    case 'raciony':
      return {
        name: 'Рационы',
        prepositional: 'о Рационах',
        descrPrepositional: 'о Рационах',
        description: 'Рационы',
        url: '/raciony/',
      };
    case 'svyaz':
      return {
        name: 'Связь',
        prepositional: 'о Связи',
        descrPrepositional: 'о Связи',
        description: 'Связь',
        url: '/svyaz/',
      };
    case 'tendernoye-soprovozhdeniye':
      return {
        name: 'Тендерное сопровождение',
        prepositional: 'о Тендерном сопровождении',
        descrPrepositional: 'о Тендерном сопровождении',
        description: 'Тендерное сопровождение',
        url: '/tendernoye-soprovozhdeniye/',
      };
    default:
  }
};
